<template>
    <div>
        <v-server-table
            :url="route('feedback.table')"
            :columns="columns"
            :options="options"
            class="trigger feedback-table"
            ref="table"
            @row-click="onRowClick($event)"
        >
            <template slot="name" slot-scope="props" width="200">
                {{ props.row.name }}
            </template>
            <template slot="notes" slot-scope="props">
                {{ props.row.notes.length > 50 ? props.row.notes.substr(0,50) + '...' : props.row.notes }}
            </template>
            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | date }}
            </template>
        </v-server-table>
        <portal to="modals" v-if="showFeedback && $can('view-feedback')">
            <b-modal
                v-model="showFeedback"
                :hideFooter="true"
                :title="uLang('app.feedback')"
                size="lg"
            >
                <div v-if="feedback">
                    <div class="feedback-block">
                        <strong>{{ uLang('app.name') }}:</strong><br>
                        {{ feedback.name }}
                    </div>
                    <div class="feedback-block">
                        <strong>{{ uLang('app.notes') }}:</strong><br>
                        {{ feedback.notes }}
                    </div>
                    <div class="feedback-block" v-if="feedback.screenshot">
                      <strong>{{ uLang('app.screenshot') }}:</strong><br><br>
                      <a :href="feedback.screenshot">
                        <img
                            :src="feedback.screenshot"
                            style="width: 100%"
                        >
                      </a>
                    </div>
                </div>
            </b-modal>
        </portal>
    </div>
</template>

<script>
    import { TableMixin } from '~/mixins'

    export default {
        name: 'FeedbackTable',
        mixins: [ TableMixin ],
        props: {
            rowsPerPage: {
                type: String,
                default: "15"
            }
        },
        data () {
            return {
                feedback: null,
                showFeedback: false,
                loading: false,
                columns: ['name', 'notes', 'created_at'],
                filterable: ['name', 'notes', 'created_at'],
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        notes: this.uLang('app.notes'),
                        created_at: this.uLang('app.sent_at'),
                    },
                    customFilters: [
                        'type',
                    ],
                },
                openToolTips: [],
            }
        },

        methods: {
            async onRowClick(clickEvent) {
                // Check if they clicked a td (the row), so not a button or something.
                if(!clickEvent.event.target.nodeName == "TD" ) {
                    this.showFeedback = false
                    return;
                }

                this.showFeedback = true

                // Do nothing if it's the same row
                if(this.feedback && this.feedback.id == clickEvent.row.id) {
                    return;
                }

                this.feedback = null
                this.loading = true
                const { data } = await window.axios.get(route('feedback.show', { feedback: clickEvent.row.id }));
                this.feedback = data
                this.loading = false
            },
        },
        watch: {
            rowsPerPage(newValue) {
                this.$refs.table.setLimit(Number.parseInt(newValue, 10));
                this.$refs.table.refresh();
            }
        }
    }
</script>

<style lang="scss">
.feedback-block {
    margin-top: 20px;

    &:first-child {
        margin-top: 0;
    }
}

.feedback-table thead tr th:first-child {
    width: 160px
}
</style>
